/**
 * YLI GA4 Navigation Tracking
 * Version: 1.0.0
 * Created: 2026-01-14
 * Purpose: Track main navigation clicks and dropdown interactions
 * GA4 Events: main_nav_click, dropdown_menu_open, collection_nav_click
 * Spec: docs/ga4-events/ga4-event-tracking-plan.md
 */

(function() {
  'use strict';

  // Track which dropdowns have been opened in this session
  var openedDropdowns = new Set();

  // GA4 Event: main_nav_click
  // Track when users click top-level navigation items
  function trackMainNavClick() {
    document.addEventListener('click', function(e) {
      var navLink = e.target.closest('[data-top-link]');
      if (!navLink) return;

      var navText = navLink.querySelector('.navtext');
      var navItem = navText ? navText.textContent.trim() : navLink.textContent.trim();
      var navUrl = navLink.getAttribute('href') || '';

      // Determine if this is a parent item (has dropdown)
      var menuItem = navLink.closest('.menu__item');
      var hasDropdown = menuItem && (menuItem.classList.contains('parent') || menuItem.classList.contains('grandparent'));

      // Determine navigation level
      var navLevel = 'top';
      if (menuItem) {
        if (menuItem.classList.contains('child')) {
          navLevel = 'dropdown';
        } else if (menuItem.classList.contains('grandparent')) {
          navLevel = 'top_with_megamenu';
        } else if (menuItem.classList.contains('parent')) {
          navLevel = 'top_with_dropdown';
        }
      }

      if (typeof gtag === 'function') {
        gtag('event', 'main_nav_click', {
          'nav_item': navItem,
          'nav_url': navUrl,
          'nav_level': navLevel,
          'has_dropdown': hasDropdown ? 'yes' : 'no'
        });
      }
    });
  }

  // GA4 Event: dropdown_menu_open
  // Track when dropdown menus are opened (hover or click)
  function trackDropdownOpen() {
    // Use MutationObserver to detect when dropdowns become visible
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          var menuItem = mutation.target;
          var isExpanded = menuItem.getAttribute('aria-expanded') === 'true';

          if (isExpanded) {
            var navLink = menuItem.querySelector('[data-top-link]');
            if (!navLink) return;

            var navText = navLink.querySelector('.navtext');
            var dropdownName = navText ? navText.textContent.trim() : '';

            // Get dropdown ID for deduplication
            var dropdownId = menuItem.getAttribute('aria-controls') || dropdownName;

            // Only fire once per dropdown per session
            if (!openedDropdowns.has(dropdownId)) {
              openedDropdowns.add(dropdownId);

              // Determine dropdown type
              var dropdownType = 'standard';
              if (menuItem.classList.contains('grandparent')) {
                dropdownType = 'mega_menu';
              } else if (menuItem.classList.contains('parent')) {
                dropdownType = 'dropdown';
              }

              // Count items in dropdown
              var dropdown = document.getElementById(dropdownId);
              var itemCount = 0;
              if (dropdown) {
                itemCount = dropdown.querySelectorAll('a').length;
              }

              if (typeof gtag === 'function') {
                gtag('event', 'dropdown_menu_open', {
                  'dropdown_name': dropdownName,
                  'dropdown_type': dropdownType,
                  'item_count': itemCount
                });
              }
            }
          }
        }
      });
    });

    // Observe all menu items with dropdowns
    var menuItems = document.querySelectorAll('hover-disclosure[aria-haspopup="true"]');
    menuItems.forEach(function(item) {
      observer.observe(item, { attributes: true, attributeFilter: ['aria-expanded'] });
    });
  }

  // GA4 Event: collection_nav_click
  // Track when users click collection links from navigation
  function trackCollectionNavClick() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('.header__dropdown a, .menu__blocks a');
      if (!link) return;

      var href = link.getAttribute('href') || '';

      // Only track collection links
      if (!href.includes('/collections/') && !href.includes('/pages/thread-')) return;

      var linkText = link.textContent.trim();

      // Determine parent dropdown
      var dropdown = link.closest('.header__dropdown');
      var parentNav = 'Unknown';
      if (dropdown) {
        var dropdownId = dropdown.getAttribute('id');
        var parentItem = document.querySelector('[aria-controls="' + dropdownId + '"]');
        if (parentItem) {
          var parentLink = parentItem.querySelector('[data-top-link] .navtext');
          parentNav = parentLink ? parentLink.textContent.trim() : 'Unknown';
        }
      }

      // Determine if this is an image block click
      var isImageBlock = link.closest('.menu__blocks') ? 'yes' : 'no';

      // Determine link type
      var linkType = 'collection';
      if (href.includes('/pages/')) {
        linkType = 'page';
      }

      if (typeof gtag === 'function') {
        gtag('event', 'collection_nav_click', {
          'link_text': linkText,
          'link_url': href,
          'parent_nav': parentNav,
          'link_type': linkType,
          'is_image_block': isImageBlock
        });
      }
    });
  }

  // Initialize tracking when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trackMainNavClick();
      trackDropdownOpen();
      trackCollectionNavClick();
    });
  } else {
    trackMainNavClick();
    trackDropdownOpen();
    trackCollectionNavClick();
  }

})();
